import React from "react";
import Modal from "react-modal";

import { Album, Resource } from 'app/api/types';

import BackButton from "app/features/BackButton";
import Loader from "app/components/Loader";

import "./styles.scss";
import AddAlbum from './components/AddAlbum';
import AlbumComponent from '../Album';
import UploadProgress from './components/UploadProgress';

interface IProps {
  isLoading: boolean;
  albums: Album[];
  progress: number;
  getAlbums: () => Album[];
  putAlbums: (album: Album) => void;
  putResource: (payload: { albumId: string, resource: Resource, file?: File, preview?: File }) => void;
  deleteAlbum: (id: string) => void;
  deleteResource: (payload: { id: string, albumId: string }) => void;
}

interface IState {
  modalIsOpen: boolean;
  isSuccessActive: boolean;
  isSubmit: boolean;
}


Modal.setAppElement("#root");

class ServiceList extends React.Component<IProps, IState> {
  state = {
    modalIsOpen: false,
    isSuccessActive: false,
    isSubmit: false,
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  addAlbum = (data: Album) => {
    this.props.putAlbums(data);
    this.setState({ isSubmit: false, isSuccessActive: false });
    this.closeModal();
  };

  onSuccessChange = (active: boolean) => {
    this.setState({ isSuccessActive: active });
  };

  render() {
    if (this.props.isLoading)
      return (
        <div className="loader-wrapper">
          <Loader />
        </div>
      );

    return (
      <div className="user-group">
        <UploadProgress progress={this.props.progress}></UploadProgress>
        <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            contentLabel="Add phrase modal"
            className="user-group__modal"
            overlayClassName="user-group__overlay"
        >
          <button onClick={this.closeModal} className="modal-close" />
          <AddAlbum
              onSubmit={this.addAlbum}
              onSuccessChange={this.onSuccessChange}
              isSubmit={this.state.isSubmit}
          />
          {this.state.isSuccessActive && (
              <button
                  onClick={() => this.setState({ isSubmit: true })}
                  className="modal-success"
              />
          )}
        </Modal>

        <div className="user-group__header">
          <div className="header__back-button">
            <BackButton to="/" />
          </div>

          <div className="header__group-label">
            <p className="label__text">Альбомы</p>
            <p className="label__counter">{this.props.albums.length}</p>
            <button className="label__add-button" onClick={this.openModal} />
          </div>
        </div>

        <div className="user-group__content">
          <div className="column">
            {this.props.albums.map((album) => (
                <AlbumComponent
                  key={album.id}
                  album={album}
                  putAlbums={this.props.putAlbums}
                  deleteAlbum={this.props.deleteAlbum}
                  deleteResource={this.props.deleteResource}
                  putResource={this.props.putResource}
                />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default ServiceList;
